// 报表状态
export const dataStataus = [{
  status: -1,
  name: "未填报",
  class: ''
},
{
  status: 0,
  name: "信息审核中",
  class: 'fcG'
},
{
  status: 1,
  name: "审核通过",
  class: 'fcR2'
},
{
  status: 2,
  name: "未过审",
  class: 'fcR'
}
]

export const ROLE_ADMIN = 1; // 超级管理员
export const ROLE_COUNTRY = 2; // 全国
export const ROLE_PROVINCE = 3; // 省
export const ROLE_CITY = 4; // 市
export const ROLE_AREA = 5; // 区
export const ROLE_SCHOOL = 6; // 学校

export const REG_ZM = /^(([a-z]+[0-9]+)|([0-9]+[a-z]+))[a-z0-9]*$/i;
export const REG_PWD =/^(?![^A-z]+$)(?!\D+$)[A-z\d]{8,12}$/;

//  大队辅导员统计内容：性别、年龄（30以下，30-40，40-50，50-60，60以上，前含后不含）、学历、政治面貌、担任大队辅导员时间（5年以下，5-10年，10-15年，15-20年，20年以上）
//  有学校少工委的学校数（填写学校少工委主任信息的学校数），各省、市、县没有学校少工委的学校数、名单。 

// 性别
export const sexArr = {
  1: '男',
  2: '女',
}

// 年龄
export const ageArr = {
  0: {
    name: '30以下',
    count: 0,
    pre: 0,
  },
  1: {
    name: '30-40',
    count: 0,
    pre: 0,
  },
  2: {
    name: '40-50',
    count: 0,
    pre: 0,
  },
  3: {
    name: '50-60',
    count: 0,
    pre: 0,
  },
  4: {
    name: '60以上',
    count: 0,
    pre: 0,
  },
}
// 学历
export const eduArr = {
  1: '全日制研究生',
  2: '在职研究生',
  3: '党校研究生',
  4: '全日制本科',
  5: '非全日制本科',
  6: '全日制大专',
  7: '非全日制大专',
  8: '其他',
}
// 政治面貌
export const zzmmArr = {
  1: '中共党员',
  2: '共青团员',
  3: '群众',
  4: '其他',
}

// 政治面貌
export const yOrn = {
 '-1': '没有',
  '1': '有',
}

// 担任大队辅导员时间
export const jobArr = {
  0: {
    name: '5年以下',
    count: 0,
    pre: 0,
  },
  1: {
    name: '5-10年',
    count: 0,
    pre: 0,
  },
  2: {
    name: '10-15年',
    count: 0,
    pre: 0,
  },
  3: {
    name: '15-20年',
    count: 0,
    pre: 0,
  },
  4: {
    name: '20年以上',
    count: 0,
    pre: 0,
  }
}

// 后端RSA公钥
export const serverPublicKey =
  "MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCvg1CkFGzCCYYUIUUBr+I5JWrmcKBt7uZhmRWtOXOB0ogHNkOUGoo3tOZyRPYgXG5FOs640QmK55ERni27L+1GBSNo4gWW4bwC5TJES+EEMWd09tfHIUQP7ezw/4q++PNnNpDTMb/WP6HazM6kxDbtigUKzQc8XS20naDSv9oR2wIDAQAB";